import React, { useState, useEffect, useContext } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
// //
import LeftToolbar from './components/LeftToolbar';
import GraphHOC from './components/GraphHOC';
import GraphLegend from './components/GraphLegend';
//
import { getConfig, nodeColorsSrcDst, linkColors } from './config';
import { isEmpty, safeGet } from '../../commons/utils';

import {
	genSnaData,
	getLegend,
	changeNodeColor,
	changeLinkColor,
	recoveryNodeColor,
	recoveryLinkColor,
	findAllLinksToNode,
	getCitedCiting,
} from './helper';
import { getPubRelationData, getPubData } from './service';
import { StoreContext } from '../../store/StoreProvider';
import Act from '../../store/actions';

const defaultSnaWidth = 1400;
const defaultSnaHeight = 500;

const RenderSNA = () => {
	//
	const [state, dispatch] = useContext(StoreContext);
	const { sna } = state;
	const { dbData, SNAData, legends, curNode, curPubData } = sna;
	//
	const [snaWidth, setSnaWidth] = useState(window.innerWidth);
	const [snaHeight, setSnaHeight] = useState(window.innerHeight - 90);
	const [snaConfig, setSnaConfig] = useState({});
	const [renderLabel, setRenderLabel] = useState(true);
	const [isFullScreen, setIsFullScreen] = useState(false);
	const [nodeFontSize, setnNodeFontSize] = useState(12);
	const [linkFontSize, setnLinkFontSize] = useState(12);
	const [loading, setLoading] = useState(true);
	const [pubInfoLoading, setPubInfoLoading] = useState(false);

	//
	useEffect(() => {
		const defaultSnaConfig = getConfig({
			snaWidth,
			defaultSnaWidth,
			snaHeight,
			renderLabel,
			nodeFontSize,
			linkFontSize,
		});
		setSnaConfig(defaultSnaConfig);
	}, [snaWidth, snaHeight, renderLabel, nodeFontSize, linkFontSize]);

	const updateWidthAndHeight = () => {
		// console.log('window.innerWidth', window.innerWidth)
		// 變更 sna svg 的長寬
		setSnaWidth(window.innerWidth);
		setSnaHeight(window.innerHeight - 130);
	};

	// update sna div width and height when window resize
	useEffect(() => {
		// get sna data
		getPubRelationData(dispatch);
		// handle window resize
		window.addEventListener('resize', updateWidthAndHeight);
		return () => window.removeEventListener('resize', updateWidthAndHeight);
	}, []);

	useEffect(() => {
		if (!Array.isArray(dbData.filter)) return;
		const newSnaData = genSnaData(dbData.filter);
		dispatch({
			type: Act.SNA_SNA_GRAPH_DATA,
			payload: newSnaData,
		});
		setLoading(false);
	}, [dbData, dbData.filter]);

	useEffect(() => {
		// 讀取 legends 資料
		if (SNAData && SNAData.nodes) {
			const curLegends = getLegend(SNAData.nodes);
			dispatch({
				type: Act.SNA_GRAPH_LEGENDS,
				payload: curLegends,
			});
		}
	}, [SNAData]);

	useEffect(
		() =>
			// 離開頁面時清空資料
			() => {
				dispatch({
					type: Act.SNA_INIT,
				});
			},
		[]
	);

	// handle click node event
	const onClickNode = async (nodeId, node) => {
		// 還原所有 node 的顏色
		recoveryNodeColor(SNAData.nodes).then((res) => {
			// 改變目前選擇的 node 的顏色
			changeNodeColor(nodeId, nodeColorsSrcDst.focus);
		});

		// 將原本的 link 區分成二群：有跟此 node 連結 & 沒有跟此 node 連結
		const { connectLink, restLink } = findAllLinksToNode(node, SNAData.links);

		// 還原所有 links 的顏色
		recoveryLinkColor(restLink).then((res) => {
			// 改變目前選擇的 node 的顏色
			changeLinkColor(
				[
					...connectLink.map((link) => `${link.source},${link.target}`),
					...connectLink.map((link) => `${link.target},${link.source}`),
				],
				linkColors.focus
			);
		});

		// keys of node: color, highlighted, id, index, nodeId, source, symbolType
		const pubId = safeGet(node, ['nodeId']);

		if (!pubId) return;
		// 取得某個 publication 的 cited pub 及 citing pub
		const citedCitingRef = getCitedCiting(dbData, nodeId);
		// get current publication data
		setPubInfoLoading(true);
		getPubData({ pubId, dispatch, initialData: { ...citedCitingRef }, setPubInfoLoading });
	};
	//
	const onMouseOverNode = (nodeId, node) => {};
	const onMouseOutNode = (nodeId, node) => {};
	const onClickLink = (source, target) => {};
	const onMouseOverLink = (source, target) => {};
	const onMouseOutLink = (source, target) => {};

	if (loading)
		return (
			<Dimmer active={loading} inverted>
				<Loader inverted content="Loading" size="massive" />
			</Dimmer>
		);

	return (
		<>
			<LeftToolbar loading={pubInfoLoading} />
			{/* <GraphLegend legends={legends} /> */}
			{!isEmpty(SNAData) && (
				<GraphHOC
					id="graph-id" // id is mandatory
					data={SNAData}
					config={snaConfig}
					onClickNode={onClickNode}
					onClickLink={onClickLink}
					onMouseOverNode={onMouseOverNode}
					onMouseOutNode={onMouseOutNode}
				/>
			)}
		</>
	);
};

export default RenderSNA;
